<footer class="footer-main zone-dark">
  <div class="footer-main-container">
    <nav class="footer-main-nav">
      <ul class="footer-main-link-items">
        <li *ngFor="let link of links" class="footer-main-link-item">
          <ng-container [ngSwitch]="link.type">
            <ng-container *ngSwitchCase="'route'">
              <ng-container *ngIf="isRoute(link)">
                <a [routerLink]="link.route" class="footer-main-link">{{
                  link.label
                }}</a>
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'link'">
              <ng-container *ngIf="isLink(link)">
                <a
                  [href]="link.href"
                  [target]="link.target"
                  class="footer-main-link"
                  >{{ link.label }}</a
                >
              </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'action'">
              <ng-container *ngIf="isAction(link)">
                <a (click)="link.cb()" class="footer-main-link">{{
                  link.label
                }}</a>
              </ng-container>
            </ng-container>
          </ng-container>
        </li>
      </ul>
    </nav>
    <div class="footer-main-logo">
      <svg
        class="navbar-logo d-inline-flex"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="138"
        height="64"
        viewBox="0 0 218 100"
      >
        <defs>
          <path id="a" d="M.798.799h85.844v61.32H.798z" />
        </defs>
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(61 .201)">
            <mask id="b" fill="#fff">
              <use xlink:href="#a" />
            </mask>
            <path
              fill="#FFF"
              d="M34.671 3.934C25.741 7.849 13 15.823 11.942 29.694l-8.636-.02C4.411 17.047 17.471 6.663 34.671 3.934zm-11.68 28.214a30.046 30.046 0 0 0 1.765 9.686 58.604 58.604 0 0 0-6.275 2.496c-2.427-3.39-4.043-7.427-4.167-12.203l8.677.02zm12.473 24.727c-4.918-2.115-11.022-5.513-15.414-10.553a57.828 57.828 0 0 1 5.643-2.202c2.514 5.549 6.36 9.8 9.771 12.755zm8.056-15.633c5.776.014 11.017.933 15.512 2.2-4.584 9.909-13.66 15.176-15.549 16.183-1.885-1.042-10.908-6.437-15.456-16.224a56.11 56.11 0 0 1 15.493-2.159zm17.85 2.91a61.202 61.202 0 0 1 5.768 2.202c-4.455 5.094-10.647 8.495-15.594 10.59 3.432-2.935 7.297-7.18 9.826-12.791zM51.533 5.907C59.928 9.432 72.014 16.75 72.91 29.838l-8.838-.02c-.55-11.361-7.12-19.276-12.538-23.912zm32.611 23.96l-8.809-.021C74.485 15.855 62.221 7.957 53.3 4.044 70.29 6.948 83.106 17.33 84.144 29.866zm-8.016 18.547c-.979-.656-2.75-1.76-5.199-2.995 2.548-3.644 4.254-7.994 4.433-13.146l8.83.02c-.24 6.037-3.197 11.605-8.064 16.12zm-13.824-6.547c1.033-2.881 1.687-6.09 1.785-9.62l8.85.02c-.183 4.732-1.808 8.735-4.223 12.093a62.428 62.428 0 0 0-6.412-2.493zm-9.329 17.086c5.282-2.3 11.796-5.998 16.441-11.541a51.664 51.664 0 0 1 4.777 2.65c-5.48 4.359-12.852 7.53-21.218 8.89zm-39.703-8.945A46.309 46.309 0 0 1 17.8 47.4C22.365 52.85 28.75 56.53 33.98 58.849c-8.156-1.42-15.338-4.564-20.708-8.842zM3.248 32.102l8.641.019c.12 5.209 1.828 9.606 4.401 13.289-2.376 1.24-4.055 2.337-4.937 2.956-4.915-4.56-7.895-10.18-8.105-16.264zm-2.45-.745c-.04 16.907 19.183 30.705 42.85 30.762 23.668.056 42.955-13.653 42.994-30.56.038-15.915-17-29.073-38.745-30.606-.082.05-1.567.965-3.658 2.689 3.548 2.057 15.663 10.082 17.273 24.496h.003c.416 3.192.03 6.237.03 6.237h-.02a28.42 28.42 0 0 1-1.542 6.78 60.58 60.58 0 0 0-16.458-2.34 58.859 58.859 0 0 0-16.45 2.303 27.694 27.694 0 0 1-1.57-7.143c-2.627-1.033-2.47-4.292-2.47-4.292.157-2.072.477-4.01.921-5.825a30.336 30.336 0 0 0-.926 5.863l-8.658-.02c1.021-11.648 11.57-18.875 19.777-22.785 4.793-4.333 9.303-6.1 9.303-6.1.14-.008.3-.012.47-.014-.04 0-.082-.002-.123-.004h-.015C20.121.747.838 14.454.798 31.357z"
              mask="url(#b)"
            />
          </g>
          <path
            fill="#FFF"
            d="M212.672 68.984l-.72-.002.002-1.166 1.164.004c.563.001 1.063.045 1.061.636 0 .637-.87.53-1.507.528m2.185-.597c.002-.987-.759-1.244-1.605-1.246l-1.972-.004-.01 4.685.675.003.005-2.162.87.002 1.191 2.164.776.002-1.182-2.165c.627-.02 1.25-.359 1.252-1.279"
          />
          <path
            fill="#FFF"
            d="M212.876 72.94a3.485 3.485 0 0 1-3.488-3.498 3.479 3.479 0 0 1 3.505-3.48 3.478 3.478 0 0 1 3.485 3.498 3.484 3.484 0 0 1-3.502 3.48m.018-7.654a4.141 4.141 0 0 0-4.184 4.155 4.141 4.141 0 0 0 4.164 4.177 4.142 4.142 0 0 0 4.185-4.158 4.14 4.14 0 0 0-4.165-4.174M12.972 66.814L.69 66.785l-.076 32.21 21.212.05.019-7.897-8.93-.022z"
          />
          <path
            fill="#FFF"
            d="M37.389 91.144c-3.413-.008-4.408-4.747-4.399-8.404.008-3.402.86-8.242 4.438-8.234 3.576.008 4.403 4.854 4.395 8.254-.01 3.658-1.023 8.392-4.434 8.384m-.01-24.958c-9.413-.022-17.091 6.792-17.116 16.867-.024 10.29 7.648 16.473 17.105 16.495 9.456.022 17.158-6.124 17.183-16.414.023-10.075-7.757-16.927-17.172-16.948M54.782 83.345c-.022 9.159 7.752 16.293 17.722 16.316 2.275.006 6.425-.38 8.466-1.27l.029-8.4c-2.055 1.398-3.898 1.778-6.514 1.423-3.587-.324-7.121-4.182-7.111-8.518.01-4.167 2.45-8.228 7.138-8.838 2.852-.372 4.734.547 6.52 2.09l.012-8.99c-2.688-.86-5.267-.88-8.141-.887-10.248-.025-18.1 7.702-18.121 17.074M114.59 67.027l-13.792-.042s-6.65 12.437-6.884 12.887l.03-12.894-12.34-.029-.077 32.271 12.341.03.032-13.157 6.593 13.138 14.33.032-9.969-16.847 9.736-15.389zM141.041 67.089l-26.28-.062-.02 8.482 6.862.018-.038 23.753 12.4.03.08-23.763 6.975.023zM196.019 83.317l-7.266-15.97-13.47-.033-.075 32.21 12.618.065.036-15.477L194.6 99.57l13.594.031.075-32.2-12.347-.029z"
          />
          <path
            fill="#FFF"
            d="M157.298 91.254c-3.493-.008-4.51-4.597-4.5-8.253.007-3.402.878-8.33 4.54-8.32 3.664.009 4.511 4.939 4.503 8.34-.009 3.657-1.049 8.242-4.543 8.233m.06-24.805c-9.638-.023-17.568 6.7-17.592 16.779-.025 10.287 7.571 16.613 17.252 16.635 9.678.024 17.828-6.264 17.852-16.552.025-10.078-7.875-16.84-17.513-16.862M86.398 31.702c-.002.845.038 1.668.106 2.474.49.193 1.065.317 1.768.319l34.251.081c.1-.961.166-1.942.168-2.959a29.084 29.084 0 0 0-.179-3.278l-31.523-.068c1.224-12.015 9.372-20.411 14.25-24.428a25.233 25.233 0 0 0-.623-.35c-2.559 1.411-18.176 10.739-18.218 28.209"
          />
          <path
            fill="#FFF"
            d="M122.524 34.576h.02s.387-3.045-.03-6.237h-.002a29.07 29.07 0 0 1 .18 3.278 29.288 29.288 0 0 1-.168 2.959M95.15 7.117c.316-.15.637-.308.947-.448-4.28 3.805-9.113 9.588-11.14 17.39a35.979 35.979 0 0 0-.923 5.825s-.156 3.258 2.47 4.292a28.555 28.555 0 0 1-.106-2.474c.042-17.47 15.66-26.798 18.218-28.209.16.086.37.203.623.35 2.091-1.724 3.576-2.639 3.658-2.69a59.215 59.215 0 0 0-3.975-.15c-.17.002-.33.006-.47.013 0 0-4.51 1.768-9.303 6.101"
          />
        </g>
      </svg>
    </div>
    <div class="footer-main-copyright">
      © {{ date | date : 'YYYY' }} {{ copyright }}
    </div>
    <div class="footer-main-terms">
      <ng-content select="[luiFooterMainTerms]"></ng-content>
    </div>
  </div>
</footer>
